export function Signup(props) {

    function handleSubmitACB(event){
        event.preventDefault();  // Förhindra form submit
        props.signUpUser();
    }

    function updateInputACB(event){
        switch(event.target.id){
            case "E":
                props.setEmail(event.target.value);
                break;  
            case "FN":
                props.setFName(event.target.value);
                break;
            case "LN":
                props.setLName(event.target.value);
                break;
            case "P":
                props.setPassword(event.target.value);
                break;
            case "CP":
                props.setComfirmPassword(event.target.value);
                break;
            default:
            break;
        }
    }

    return (
        <form onSubmit={handleSubmitACB} className="space-y-4">
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Email: </label>
                {props.emailError && <span className="text-red-700 text-sm mb-1">{ " " + props.emailError}</span>}
              </div>
            <input
                id="E"
                type="text"
                placeholder="Enter email"
                onChange={updateInputACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={true}
            />
            </div>
            
            <div>
              <div>
                <label className="block text-blue-900 mb-1">First Name: </label>
                {props.fNameError && <span className="text-red-700 text-sm mb-1">{ " " + props.fNameError}</span>}
              </div>
              <input
                id="FN"
                type="text"
                placeholder="Enter your first name"
                onChange={updateInputACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={true}
              />
            </div>
            
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Last Name: </label>
                {props.lNameError && <span className="text-red-700 text-sm mb-1">{ " " + props.lNameError}</span>}
              </div>
              <input
                id="LN"
                type="text"
                placeholder="Enter your last name"
                onChange={updateInputACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={true}
              />
            </div>
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Password: </label>
                {props.passwordError && <span className="text-red-700 text-sm mb-1">{" " + props.passwordError}</span>}
              </div>
              <input
                id="P"
                type="password"
                placeholder="Choose a password"
                onChange={updateInputACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={true}
              />
            </div>
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Confirm Password: </label>
                {props.confirmPasswordError && <span className="text-red-700 text-sm mb-1">{ " " + props.confirmPasswordError}</span>}
              </div>
              <input
                id="CP"
                type="password"
                placeholder="Confirm your password"
                onChange={updateInputACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={true}
              />
            </div>
            <button
              type="submit"
              className="flex items-center justify-center w-full py-3 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all shadow-md"
            >
                Sign Up
            </button>
          </form>
    );
}